import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Compass, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full rounded-xl border border-warm/15 bg-warm/5 px-4 py-3 text-sm text-warm placeholder:text-warm/40 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold";

  return (
    <div className="min-h-screen bg-navy-deep flex items-center justify-center px-6 relative overflow-hidden">
      <Seo title="Admin — Effizent Europe" description="Admin login" />
      <div className="spotlight absolute inset-0 pointer-events-none" />
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-sm rounded-3xl border border-warm/10 bg-navy p-8">
        <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/50 bg-gold/10 mx-auto"><Compass className="h-6 w-6 text-gold" /></span>
        <h1 className="font-playfair text-2xl text-warm text-center mt-5">Effizent Europe</h1>
        <p className="text-warm/50 text-sm text-center mt-1">Admin dashboard</p>
        <div className="mt-7 space-y-3">
          <input data-testid="admin-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} required />
          <input data-testid="admin-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={field} required />
        </div>
        {error && <p data-testid="admin-error" className="text-terracotta text-sm mt-3">{error}</p>}
        <button data-testid="admin-submit" disabled={loading} className="mt-6 w-full rounded-full bg-gold py-3 font-600 text-navy hover:bg-gold-soft transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
          <Lock className="h-4 w-4" /> {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
